var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.556,
    height: 14.439,
    viewBox: "0 0 8.556 14.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down-arrow",
    d: "M14.034.4A1.37,1.37,0,0,0,12.1.4L7.185,5.247,2.337.4A1.371,1.371,0,1,0,.405,2.343L6.213,8.151a1.37,1.37,0,0,0,1.945,0l5.876-5.808a1.37,1.37,0,0,0,0-1.945Z",
    transform: "translate(8.556) rotate(90)",
    fill: "#304669",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowLeftIcon);
export default __webpack_public_path__ + "static/media/KeyboardArrowLeftIcon.dd0357efdca3f4cfb9eef9e8f4125d85.svg";
export { ForwardRef as ReactComponent };